import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {FilterSliceType, SwitchFilters} from "./Types";

const initialState : FilterSliceType = {
  dashboardFilters : {
    shippingPending: false,
    shippingSchedule: false,
    shippingPickup: false,
    shipmentInTransit: false
  }
};

const FilterSlice = createSlice({
  name:"Filters",
  initialState,
  reducers : {
    setDashboardFilters(state, {payload}: PayloadAction<SwitchFilters>){
      state.dashboardFilters = payload;
    }
  }
});

export const FilterActions = FilterSlice.actions;

export default FilterSlice.reducer;
